import { useTranslationInfo } from '../useTranslationInfo.js';
import { getTranslationKey } from '../utils/getTranslationKey.js';
export const useTranslationInfoHighlight = (resource, prefix, options) => {
    const { translationInfo } = useTranslationInfo();
    if (!translationInfo) {
        return false;
    }
    return (translationInfo.resource === resource &&
        translationInfo.prefix === prefix &&
        getTranslationKey(translationInfo.options) === getTranslationKey(options));
};
//# sourceMappingURL=useTranslationInfoHighlight.js.map